export function secondsToMs(timeSeconds) {
    return timeSeconds * 1000;
}
export function getTimeNow() {
    var _self_performance;
    return ((_self_performance = self.performance) === null || _self_performance === void 0 ? void 0 : _self_performance.now) ? self.performance.now() : new Date().getTime();
}

//# sourceMappingURL=time-util.js.map